import type React from "react";

import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";
import { useTheme } from "styled-components";

import type { GetPatientGoalsResponse } from "api/types/GetPatientGoals";
import { MUIAccordion, MUIAccordionDetails, MUIAccordionSummary } from "shared/atoms/MUIAccordion";

import { CardTitle } from "./Goal";
import { Row } from "./NonEditGoal";

interface Props {
  data: GetPatientGoalsResponse | undefined;
}

export const PastGoals: React.FC<Props> = ({ data }) => {
  const { t } = useTranslation();
  const theme = useTheme();

  const pastGoals = data?.map(({ id: goalID, free_text: description, pain, functionality }, index) => {
    return index !== 0 ? (
      <MUIAccordion key={goalID}>
        <MUIAccordionSummary>
          <Typography variant="subtitle1">{description ?? "-"}</Typography>
        </MUIAccordionSummary>
        <MUIAccordionDetails>
          <Stack>
            <Row>
              <Typography variant="subtitle1" sx={{ color: theme.colors.redesign.db60 }}>
                {t("dashboard.tables.calls.goal.description")}
              </Typography>
              <Typography variant="subtitle1">{description ?? "-"}</Typography>
            </Row>
            <Row>
              <Typography variant="subtitle1" sx={{ color: theme.colors.redesign.db60 }}>
                {t("dashboard.tables.calls.goal.pain")}
              </Typography>
              <Typography variant="subtitle1">{pain ?? "-"}</Typography>
            </Row>
            <Row>
              <Typography variant="subtitle1" sx={{ color: theme.colors.redesign.db60 }}>
                {t("dashboard.tables.calls.goal.function")}
              </Typography>
              <Typography variant="subtitle1">{functionality ?? "-"}</Typography>
            </Row>
          </Stack>
        </MUIAccordionDetails>
      </MUIAccordion>
    ) : null;
  });

  return (
    <>
      <CardTitle>
        <Typography variant="h5">{t("patients.past_goals")}</Typography>
      </CardTitle>
      <Stack sx={{ padding: "16px 0" }}>
        {data !== undefined && data?.length > 1 ? (
          pastGoals
        ) : (
          <Typography variant="subtitle1">{t("patients.no_past_goals")}</Typography>
        )}
      </Stack>
    </>
  );
};
